export default __webpack_public_path__ + "static/media/list_image.a95501e8.svg";